// Aviso de contacto repetido: antes de criar um contacto, procura nos contactos DO MESMO CONSULTOR
// alguém com o mesmo telefone ou o mesmo email. O mesmo cliente pode ser contacto de consultores
// diferentes (ex.: vende com um e compra com outro), por isso só se compara dentro do mesmo consultor.
import { createRoot } from "react-dom/client";

const digitos = (t) => String(t || "").replace(/\D/g, "").slice(-9); // ignora indicativo +351
const mailNorm = (e) => String(e || "").trim().toLowerCase();

export async function procurarContactoRepetido(supabase, { telefone, email }, consultorId) {
  const tel = digitos(telefone), mail = mailNorm(email);
  if (!consultorId || (tel.length < 9 && !mail.includes("@"))) return null;
  const { data } = await supabase.from("leads").select("id, nome, nome_completo, telefone, email, created_at, consultor_nome")
    .eq("consultor_id", consultorId).is("deleted_at", null);
  return (data || []).find(l => (tel.length >= 9 && digitos(l.telefone) === tel) || (mail.includes("@") && mailNorm(l.email) === mail)) || null;
}

// Mostra o aviso e devolve "existente" | "criar" | "cancelar"
export function perguntarContactoRepetido(existente, { textoExistente = "📂 Abrir o existente" } = {}) {
  return new Promise((resolver) => {
    const el = document.createElement("div");
    document.body.appendChild(el);
    const root = createRoot(el);
    const fim = (r) => { root.unmount(); el.remove(); resolver(r); };
    const btn = (bg, cor, borda) => ({ background: bg, color: cor, border: borda ? `1.5px solid ${borda}` : "none", borderRadius: 9, padding: "9px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer" });
    root.render(
      <div onClick={() => fim("cancelar")} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 5000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: "'DM Sans', sans-serif" }}>
        <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 22, maxWidth: 440, width: "100%" }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#b45309", marginBottom: 8 }}>⚠️ Já tens este contacto</div>
          <div style={{ background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 10, padding: "10px 12px", fontSize: 13, marginBottom: 14 }}>
            <div style={{ fontWeight: 700 }}>{existente.nome_completo || existente.nome || "—"}</div>
            <div style={{ color: "#6b7280", fontSize: 12 }}>{[existente.telefone, existente.email].filter(Boolean).join(" · ")}{existente.created_at ? ` · criado a ${new Date(existente.created_at).toLocaleDateString("pt-PT")}` : ""}</div>
          </div>
          <div style={{ fontSize: 12.5, color: "#6b7280", marginBottom: 14 }}>Tem o mesmo telefone ou email. Queres usar o contacto que já existe?</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
            <button onClick={() => fim("cancelar")} style={btn("#fff", "#6b7280", "#ece9e3")}>Cancelar</button>
            <button onClick={() => fim("criar")} style={btn("#fff", "#b45309", "#fde68a")}>Criar mesmo assim</button>
            <button autoFocus onClick={() => fim("existente")} style={btn("#12244f", "#fff")}>{textoExistente}</button>
          </div>
        </div>
      </div>
    );
  });
}
